import React from 'react';
import { BaseEdge, EdgeLabelRenderer, getSmoothStepPath } from '@xyflow/react';
import AutomationBuilderAddNodesButton from './AutomationBuilderAddNodesButton';

export default function AutomationButtonEdge({
    sourceX,
    sourceY,
    targetX,
    targetY,
    sourcePosition,
    targetPosition,
    style = {},
    markerEnd,
    ...rest
}) {
    const [edgePath, labelX, labelY] = getSmoothStepPath({
        sourceX,
        sourceY,
        sourcePosition,
        targetX,
        targetY,
        targetPosition,
        borderRadius: 0,
    });

    return (
        <>
            <BaseEdge path={edgePath} markerEnd={markerEnd} style={style} />
            <EdgeLabelRenderer>
                <div
                    className="fm-automation-button-edge__label nodrag nopan"
                    style={{
                        transform: `translate(-50%, -50%) translate(${targetX}px,${targetY - 20}px)`,
                    }}
                >
                    <AutomationBuilderAddNodesButton parentId={rest.source} />
                </div>
            </EdgeLabelRenderer>
        </>
    );
}
